import { useMemo } from 'react'

import { toInstructorSummary } from './instructorPresentation'
import { useProfessors } from '../../context'

import type { InstructorSummary } from '../pages/Dasboard/_components/types'

export const useInstructorSummaries = () => {
  const { professorsList } = useProfessors()

  const instructors = useMemo<InstructorSummary[]>(
    () => (professorsList ?? []).map(toInstructorSummary),
    [professorsList],
  )

  return {
    instructors,
    loading: professorsList === null,
  }
}
